function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.27339,
  cy: 7.9073,
  r: 7.3072
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.8375,
  cy: 7.90732,
  r: 1.21787,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.7091,
  cy: 7.90732,
  r: 1.21787,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.2104,
  cy: 14.7579,
  r: 5.9371,
  fill: "#F1F2F5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6682 16.7339V15.7924H13.8395V12.79L12.9425 13.3164L12.5051 12.4787L14.1731 11.5075H14.9886V15.7924H16.0857V16.7339H12.6682Z",
  fill: "#23244D",
  fillOpacity: 0.5
});

var SvgCompetitors1Icon = function SvgCompetitors1Icon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompetitors1Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/competitors-1-icon.c2c5dc58.svg";
export { ForwardRef as ReactComponent };